export default __webpack_public_path__ + "static/media/design.d8d1f8f4.svg";